import { Injectable } from '@angular/core';
export const DEFAULT_VALUES: any = {
  limit: 25,
  offset: 0,
  sortBy: 'createdon',
  direction: 'asc'
};
@Injectable({
  providedIn: 'root'
})



export class UnderutilizationFiltersService {

  constructor() { }
}
